import React from 'react';
import { Panel } from 'reactflow';
import Style from './PropertyPanel.module.css';

const TransformPanel = ({
  edge,
  transformationType,
  transformOptions,
  onUpdateOptions,
  onSave,
  onCancel
}) => {
  // Render different options based on transformation type
  const renderTransformOptions = () => {
    switch(transformationType) {
      case 'formatCurrency':
        return (
          <div className={Style.stack}>
            <div>
              <label className={Style.label}>Currency</label>
              <select
                value={transformOptions.currency || 'USD'}
                onChange={(e) => onUpdateOptions({ currency: e.target.value })}
                className={Style.input}
              >
                <option value="USD">USD ($)</option>
                <option value="EUR">EUR (€)</option>
                <option value="GBP">GBP (£)</option>
                <option value="JPY">JPY (¥)</option>
              </select>
            </div>
            <div>
              <label className={Style.label}>Decimal Places</label>
              <select
                value={transformOptions.decimals || '2'}
                onChange={(e) => onUpdateOptions({ decimals: e.target.value })}
                className={Style.input}
              >
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </div>
          </div>
        );

      case 'formatDate':
        return (
          <div className={Style.stack}>
            <div>
              <label className={Style.label}>Date Format</label>
              <select
                value={transformOptions.format || 'MM/DD/YYYY'}
                onChange={(e) => onUpdateOptions({ format: e.target.value })}
                className={Style.input}
              >
                <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                <option value="MMM DD, YYYY">MMM DD, YYYY</option>
              </select>
            </div>
          </div>
        );

      case 'formatNumber':
        return (
          <div className={Style.stack}>
            <div>
              <label className={Style.label}>Decimal Places</label>
              <select
                value={transformOptions.precision || '2'}
                onChange={(e) => onUpdateOptions({ precision: e.target.value })}
                className={Style.input}
              >
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
              </select>
            </div>
            <div className={Style.checkbox}>
              <input
                type="checkbox"
                id="thousands-separator"
                checked={transformOptions.thousandSeparator || false}
                onChange={(e) => onUpdateOptions({ thousandSeparator: e.target.checked })}
                className={Style.checkboxInput}
              />
              <label htmlFor="thousands-separator" className={Style.checkboxLabel}>
                Use thousands separator
              </label>
            </div>
          </div>
        );

      case 'uppercase':
      case 'lowercase':
      case 'titleCase':
      case 'trim':
        return (
          <div className={Style.note}>
            No additional configuration needed for this transformation type.
          </div>
        );

      case 'custom':
        return (
          <div className={Style.stack}>
            <div>
              <label className={Style.label}>Custom Transform</label>
              <textarea
                placeholder="Enter custom transformation code"
                value={transformOptions.code || ''}
                onChange={(e) => onUpdateOptions({ code: e.target.value })}
                className={`${Style.input} ${Style.textarea}`}
              />
            </div>
          </div>
        );

      default:
        return (
          <div className={Style.emptyNote}>
            No configuration options available for this transformation type.
          </div>
        );
    }
  };

  return (
    <Panel position="top-right" className={Style.panel}>
      <div className={Style.header}>
        <h3 className={Style.title}>Configure Transformation</h3>
        <button
          type="button"
          onClick={onCancel}
          className={Style.close}
          aria-label="Close"
        >
          <i className="uil-times" aria-hidden="true" />
        </button>
      </div>
      <div className={`${Style.body} ${Style.bodyLoose}`}>
        <div className={Style.sectionTitle}>
          <i className={`uil-setting ${Style.sectionIcon}`} aria-hidden="true" />
          {transformationType === 'none' ?
            'No transformation selected' :
            `${transformationType.charAt(0).toUpperCase() + transformationType.slice(1)} Configuration`
          }
        </div>

        {renderTransformOptions()}

        <div className={Style.actions}>
          <button
            type="button"
            className={`${Style.button} ${Style.buttonBlue}`}
            onClick={onSave}
          >
            <i className="uil-save" aria-hidden="true" />
            Save
          </button>
          <button
            type="button"
            className={`${Style.button} ${Style.buttonOutline}`}
            onClick={onCancel}
          >
            <i className="uil-times" aria-hidden="true" />
            Cancel
          </button>
        </div>
      </div>
    </Panel>
  );
};

export default TransformPanel;
